export default __webpack_public_path__ + "static/image-8-85a475327b89c054c93479e0be27f523.jpg";